import { FinalImpactScoreType } from '@upright/common/model/output/scores/types';
import { RenderViewImpactChartParams } from '@upright/common/renderer/component-types/types-render-view-impact-chart';
import { RenderViewComponentType } from '@upright/common/renderer/types';
import { friendlyScoreUnit } from '@upright/common/utils';
import { useGetRenderViewComponentParamSetter } from '../../../context/component-param-setter';
import {
  ControlRoot,
  ControlRowContent,
  ControlRowLabel,
  RadioButton,
  RadioButtonsWrap,
} from '../../../controls/shared';

export const ScoreType = (props: { params: Pick<RenderViewImpactChartParams, 'scoreType'> }) => {
  const { params } = props;
  const setParams = useGetRenderViewComponentParamSetter(RenderViewComponentType.IMPACT_CHART);
  const scoreType = params.scoreType ?? FinalImpactScoreType.CENTS_PER_DOLLAR;

  return (
    <ControlRoot>
      <ControlRowLabel>Score type</ControlRowLabel>
      <ControlRowContent>
        <RadioButtonsWrap>
          <RadioButton
            checked={scoreType === FinalImpactScoreType.CENTS_PER_DOLLAR}
            onSelect={() => {
              setParams(curr => ({ ...curr, scoreType: FinalImpactScoreType.CENTS_PER_DOLLAR }));
            }}
            label={friendlyScoreUnit(FinalImpactScoreType.CENTS_PER_DOLLAR)}
          />
          <RadioButton
            checked={scoreType === FinalImpactScoreType.DOLLARS_PER_YEAR}
            onSelect={() => {
              setParams(curr => ({ ...curr, scoreType: FinalImpactScoreType.DOLLARS_PER_YEAR }));
            }}
            label={friendlyScoreUnit(FinalImpactScoreType.DOLLARS_PER_YEAR)}
          />
          <RadioButton
            checked={scoreType === FinalImpactScoreType.RELATIVE}
            onSelect={() => {
              setParams(curr => ({ ...curr, scoreType: FinalImpactScoreType.RELATIVE }));
            }}
            label={friendlyScoreUnit(FinalImpactScoreType.RELATIVE)}
          />
          <RadioButton
            checked={scoreType === FinalImpactScoreType.ABSOLUTE}
            onSelect={() => {
              setParams(curr => ({ ...curr, scoreType: FinalImpactScoreType.ABSOLUTE }));
            }}
            label={friendlyScoreUnit(FinalImpactScoreType.ABSOLUTE)}
          />
        </RadioButtonsWrap>
      </ControlRowContent>
    </ControlRoot>
  );
};
